'use client'

import type { StudentProgress } from '@/payload-types'
import { IconExclamationCircle } from '@tabler/icons-react'
import type { DefaultCellComponentProps } from 'payload'

type MentorCheckNode = NonNullable<StudentProgress['mentorCheckNodes']>[0]

export function MentorCheckNodeCell({ cellData, rowData }: DefaultCellComponentProps) {
  // cellData is an array of mentor check nodes
  const mentorCheckNodes = Array.isArray(cellData) ? (cellData as MentorCheckNode[]) : []

  // Show only nodes with 'submitted' status that need mentor attention
  const nodesNeedingApproval = mentorCheckNodes.filter(
    (node: MentorCheckNode) => node.status === 'submitted' && node.id,
  )

  // If no nodes need approval, don't render anything
  if (nodesNeedingApproval.length === 0) {
    return null
  }

  // Get the document ID from rowData
  const documentId = (rowData as { id?: number })?.id

  if (!documentId) {
    return <div className="text-red-500 text-xs">Missing document ID</div>
  }

  return (
    <a className="flex no-underline" href={`/admin/collections/student-progress/${documentId}`}>
      <div className="inline-flex items-center px-4 py-2 text-sm font-medium text-red-700 bg-red-100 border border-red-300 rounded-md cursor-pointer gap-1.5 transition-all hover:bg-red-200 hover:shadow-sm">
        <IconExclamationCircle size={16} />
        {nodesNeedingApproval.length} node(s) for approval
      </div>
    </a>
  )
}
